export function addCurrent(additionalcalledcosts) {
  return {
      type: 'ADD_CURRENT',
      additionalcalledcosts,
  }
}
